import React from 'react';
import Button from '@components-clean/core/button';
import { MessageType, ShowMessage } from '@utils/notification';

const ToastNotificationsPage = () => {
    const showMessageType = (type: MessageType) => {
        ShowMessage({ text: `Date: ${String(new Date())}`, type });
    };

    return (
        <div className="k-d-flex-row">
            <div className="k-pr-2">
                <Button onClick={() => showMessageType('none')} data-testid="show-toast-button" primary>
                    Show normal message
                </Button>
            </div>
            <div className="k-pr-2">
                <Button onClick={() => showMessageType('error')} data-testid="show-toast-button" primary>
                    Show error message
                </Button>
            </div>
            <div className="k-pr-2">
                <Button onClick={() => showMessageType('info')} data-testid="show-toast-button" primary>
                    Show info message
                </Button>
            </div>
            <div className="k-pr-2">
                <Button onClick={() => showMessageType('warning')} data-testid="show-toast-button" primary>
                    Show warning message
                </Button>
            </div>
            <div>
                <Button onClick={() => showMessageType('success')} data-testid="show-toast-button" primary>
                    Show success message
                </Button>
            </div>
        </div>
    );
};

export default ToastNotificationsPage;
